import http from '@http';
import apis from './apis';

const axios = http();

export default class SystemService {
    static getTimes(params) {
        return axios.post(apis.getTurnTimesData, params);
    }
    static getPrize(params) {
        return axios.post(apis.getJoinAcive, params);
    }
    static getUserCode(params) {
        return axios.post(apis.getPhoneCode, params); //验证码
    }
    static getLoginUpdate(params) {
        return axios.post(apis.getLoginApp, params); //验证码
    }
    static getPrizeNow(params) {
        return axios.post(apis.getPrize, params); //验证码
    }
}